import type { BuildVehicleSelects } from '../types';
import { selectOrder } from '../types';

// Normalize filter values and dropdown options to lowercase for case-insensitive comparison
export const normalizeValue = (value: string): string => {
    return value.toLowerCase();
};

// Find matching option regardless of case
export const findCaseInsensitiveMatch = (options: string[], value: string | undefined): string => {
    if (!value) {
        return '';
    }

    const normalizedValue = normalizeValue(value);
    const match = options.find((option) => normalizeValue(option) === normalizedValue);
    return match || '';
};

// Clear next steps in the select order based on the current selection
export const clearNextSteps = (selectName: BuildVehicleSelects, selectValues: Record<BuildVehicleSelects, string>) => {
    const nextSteps = selectOrder.slice(selectOrder.indexOf(selectName) + 1);

    nextSteps.forEach((nextSelectName) => {
        selectValues[nextSelectName] = '';
    });
};
